import React from "react";
import { Button } from "@mui/material";
import addplanimage from "../assets/landing_page/new/illus.png";
import { useNavigate } from "react-router-dom";
function EmptyPage() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/home/myplans");
  };
  return (
    <div
      style={{
        border: "2px dotted #ccc",
        borderRadius: "8px",
        padding: "20px",
        textAlign: "center",
        margin: "0 auto",
        height: "100vh",
        width: "95%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Center content vertically
        alignItems: "center", // Center content horizontally
      }}>
      <img
        src={addplanimage}
        alt='Placeholder'
        style={{
          width: "150px",
          height: "150px",
          objectFit: "cover",
          marginBottom: "16px",
        }}
      />
      <div
        style={{
          marginBottom: "16px",
          fontFamily: "Inter, sans-serif", // Include fallback font
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "16.94px",
          textAlign: "left",
        }}>
        Thank you for your interest.
      </div>
      <div
        style={{
          marginBottom: "16px",
          fontFamily: "Inter, sans-serif", // Include fallback font
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "16.94px",
          textAlign: "left",
        }}>
        This feature is going to be released very shortly. 
      </div>
      <Button
        variant='contained'
        onClick={handleClick}
        sx={{
          fontFamily: "Inter, sans-serif",
          textTransform: "none",
          fontWeight: 500,
          backgroundColor: "#FF2800",
          padding: "6px 16px",
          "&:hover": {
            backgroundColor: "#FF2800",
          },
        }}>
        My Plans
      </Button>
    </div>
  );
}

export default EmptyPage;
